<template>
  <div class="tva-header">
    <div class="left-box">
      <img :src="`${baseUrl}images/logo.png`" />
      <div class="tva-header-title">TVA WEB TEMPLATE</div>
    </div>
    <div class="right-box">
      <a
        class="link"
        href="https://app.nuclino.com/The-Visual-Agency/Digital-Design-Process"
        target="_blank"
      >digital design process</a>
      <TvaLangSwitcher />
      <TvaSocialSharing />
    </div>
  </div>
</template>
<script>
import TvaSocialSharing from "@/utilities/TvaSocialSharing.vue";
import TvaLangSwitcher from "@/utilities/TvaLangSwitcher.vue";
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    TvaSocialSharing,
    TvaLangSwitcher
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
.tva-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  z-index: 2;
  padding: 0 2em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-box,
  .right-box {
    display: flex;
    align-items: center;
    height: 100%;
    .link {
      @include overline-black-left;
      text-decoration: none;
    }
    img {
      height: 40%;
      margin-right: 10px;
    }
  }
}
</style>
